// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as MenuList$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/menu-list/MenuList.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as AllocationFilterWrapper from "../allocation-filters/AllocationFilterWrapper.bs.js";
import * as TableWithRowHover$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableWithRowHover.bs.js";
import * as AllocationCampaignVmVMMapper from "../../../view-model/filter-allocation-dashboard-list/AllocationCampaignVmVMMapper.bs.js";

function execute(items) {
  return List.map((function (param) {
                var action_cb = param.action_cb;
                var item = param.item;
                return {
                        item_label: {
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return item;
                            })
                        },
                        item_cb: (function (param) {
                            return Curry._1(action_cb, undefined);
                          })
                      };
              }), items);
}

var MenuListBuilder = {
  execute: execute
};

function getTableSchema(user_type, active_campaign, dispatch) {
  return {
          hd: TableWithRowHover$Catalyst.Schema.make_props({
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement("p", undefined, "About Campaign");
                  })
              }, (function (apr) {
                  return {
                          TAG: /* Custom */5,
                          _0: (function (param) {
                              var match = apr.campaign_status;
                              var tmp;
                              switch (match) {
                                case /* Active */0 :
                                    tmp = null;
                                    break;
                                case /* Scheduled */1 :
                                    tmp = user_type !== 1 && user_type === 0 ? React.createElement(MenuList$Catalyst.make, {
                                            className: "action-hamburger",
                                            postfixIcon: /* Hamburger */1,
                                            menuItems: execute({
                                                  hd: {
                                                    item: "Delete",
                                                    action_cb: (function (param) {
                                                        return Curry._1(dispatch, {
                                                                    TAG: /* UpdateSidebarState */6,
                                                                    opened_sidebar: /* ViewCampaignDetail */{
                                                                      campaign: apr
                                                                    }
                                                                  });
                                                      })
                                                  },
                                                  tl: /* [] */0
                                                }),
                                            custom_menu_button: "…"
                                          }) : null;
                                    break;
                                case /* PendingForReview */2 :
                                    tmp = user_type !== 1 ? (
                                        user_type !== 0 ? null : React.createElement(MenuList$Catalyst.make, {
                                                className: "action-hamburger",
                                                menuItems: execute({
                                                      hd: {
                                                        item: "Reject",
                                                        action_cb: (function (param) {
                                                            return Curry._1(dispatch, {
                                                                        TAG: /* UpdateSidebarState */6,
                                                                        opened_sidebar: /* ViewCampaignDetail */{
                                                                          campaign: apr
                                                                        }
                                                                      });
                                                          })
                                                      },
                                                      tl: {
                                                        hd: {
                                                          item: "Approve",
                                                          action_cb: (function (param) {
                                                              return Curry._1(dispatch, {
                                                                          TAG: /* UpdateSidebarState */6,
                                                                          opened_sidebar: /* ViewCampaignDetail */{
                                                                            campaign: apr
                                                                          }
                                                                        });
                                                            })
                                                        },
                                                        tl: /* [] */0
                                                      }
                                                    }),
                                                custom_menu_button: "…"
                                              })
                                      ) : React.createElement(MenuList$Catalyst.make, {
                                            className: "action-hamburger",
                                            menuItems: execute({
                                                  hd: {
                                                    item: "Delete",
                                                    action_cb: (function (param) {
                                                        return Curry._1(dispatch, {
                                                                    TAG: /* UpdateSidebarState */6,
                                                                    opened_sidebar: /* ViewCampaignDetail */{
                                                                      campaign: apr
                                                                    }
                                                                  });
                                                      })
                                                  },
                                                  tl: /* [] */0
                                                }),
                                            custom_menu_button: "…"
                                          });
                                    break;
                                
                              }
                              var value = apr.effective_till;
                              return React.createElement("div", {
                                          className: "campaign-name-and-action-wrapper"
                                        }, React.createElement("p", {
                                              className: "action-hamburger-wrapper"
                                            }, tmp), React.createElement("div", {
                                              className: "campaign-name-and-date"
                                            }, React.createElement("p", {
                                                  className: "campaign-name",
                                                  onClick: (function (_event) {
                                                      return Curry._1(dispatch, {
                                                                  TAG: /* UpdateSidebarState */6,
                                                                  opened_sidebar: /* ViewCampaignDetail */{
                                                                    campaign: apr
                                                                  }
                                                                });
                                                    })
                                                }, apr.name), React.createElement("p", {
                                                  className: "campaign-date"
                                                }, Timestamp$Catalyst.toString(apr.effective_from, "MMM DD, YYYY") + " - " + (
                                                  value !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(value), "MMM DD, YYYY") : "PRESENT"
                                                ))));
                            })
                        };
                }), undefined, undefined),
          tl: {
            hd: TableWithRowHover$Catalyst.Schema.make_props({
                  TAG: /* Custom */1,
                  _0: (function (param) {
                      return React.createElement("div", {
                                  className: "allocation-dashboard-table-header"
                                }, React.createElement("h4", undefined, "Allocation Radius"), React.createElement("div", undefined, React.createElement("span", undefined, "Auto"), React.createElement("span", undefined, "  -  "), React.createElement("span", undefined, "Manual")));
                    })
                }, (function (apr) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                var match = apr.campaign_status;
                                return React.createElement("div", {
                                            className: ""
                                          }, React.createElement(AllocationFilterWrapper.make, {
                                                filter_data: {
                                                  TAG: /* AllocationRadius */0,
                                                  filter_value: {
                                                    left_value: apr.filters.allocation_radius.auto,
                                                    right_value: apr.filters.allocation_radius.manual
                                                  },
                                                  delta_value: match !== 0 ? ({
                                                        left_value: apr.filters.allocation_radius.auto - active_campaign.filters.allocation_radius.auto,
                                                        right_value: apr.filters.allocation_radius.manual - active_campaign.filters.allocation_radius.manual
                                                      }) : undefined
                                                },
                                                show_header: false
                                              }));
                              })
                          };
                  }), undefined, undefined),
            tl: {
              hd: TableWithRowHover$Catalyst.Schema.make_props({
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement("div", {
                                    className: "allocation-dashboard-table-header"
                                  }, React.createElement("h4", undefined, "Dry Run Ratio [Auto]"), React.createElement("div", undefined, React.createElement("span", undefined, "Threshold"), React.createElement("span", undefined, "  -  "), React.createElement("span", undefined, "Ratio")));
                      })
                  }, (function (apr) {
                      return {
                              TAG: /* Custom */5,
                              _0: (function (param) {
                                  var match = apr.campaign_status;
                                  return React.createElement("div", {
                                              className: ""
                                            }, React.createElement(AllocationFilterWrapper.make, {
                                                  filter_data: {
                                                    TAG: /* DryRun */1,
                                                    filter_value: {
                                                      left_value: apr.filters.dry_run.threshold,
                                                      right_value: apr.filters.dry_run.ratio
                                                    },
                                                    delta_value: match !== 0 ? ({
                                                          left_value: apr.filters.dry_run.threshold - active_campaign.filters.dry_run.threshold,
                                                          right_value: apr.filters.dry_run.ratio - active_campaign.filters.dry_run.ratio
                                                        }) : undefined
                                                  },
                                                  show_header: false
                                                }));
                                })
                            };
                    }), undefined, undefined),
              tl: {
                hd: TableWithRowHover$Catalyst.Schema.make_props({
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement("div", {
                                      className: "allocation-dashboard-table-header"
                                    }, React.createElement("h4", undefined, "Max Dry Run"), React.createElement("div", undefined, React.createElement("span", undefined, "Auto"), React.createElement("span", undefined, "  -  "), React.createElement("span", undefined, "Manual")));
                        })
                    }, (function (apr) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    var match = apr.campaign_status;
                                    return React.createElement("div", {
                                                className: ""
                                              }, React.createElement(AllocationFilterWrapper.make, {
                                                    filter_data: {
                                                      TAG: /* MaxDryRun */2,
                                                      filter_value: {
                                                        left_value: apr.filters.maps_distance.auto,
                                                        right_value: apr.filters.maps_distance.manual
                                                      },
                                                      delta_value: match !== 0 ? ({
                                                            left_value: apr.filters.maps_distance.auto - active_campaign.filters.maps_distance.auto,
                                                            right_value: apr.filters.maps_distance.manual - active_campaign.filters.maps_distance.manual
                                                          }) : undefined
                                                    },
                                                    show_header: false
                                                  }));
                                  })
                              };
                      }), undefined, undefined),
                tl: /* [] */0
              }
            }
          }
        };
}

function AllocationCampaignTable(Props) {
  var active_campaign = Props.active_campaign;
  var filtered_campaings_view = Props.filtered_campaings_view;
  var state = Props.state;
  var user_type = Props.user_type;
  var dispatch = Props.dispatch;
  var active_campaign$1 = AllocationCampaignVmVMMapper.VMMapper.getViewModel(state, active_campaign);
  return React.createElement(React.Fragment, undefined, React.createElement(TableWithRowHover$Catalyst.make, {
                  columns: getTableSchema(user_type.access_level, active_campaign$1, dispatch),
                  row_data: List.map((function (filtered_campaing) {
                          return AllocationCampaignVmVMMapper.VMMapper.getViewModel(state, filtered_campaing);
                        }), filtered_campaings_view),
                  class_name: "allocation-dashboard-campaign-table"
                }));
}

var make = AllocationCampaignTable;

export {
  MenuListBuilder ,
  getTableSchema ,
  make ,
  
}
/* react Not a pure module */
